import script from "./AssetsList.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetsList.vue?vue&type=script&setup=true&lang=js"

import "./AssetsList.vue?vue&type=style&index=0&id=6d2f99a8&lang=scss&scoped=true"
import "./AssetsList.vue?vue&type=style&index=1&id=6d2f99a8&lang=css"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d2f99a8"]])

export default __exports__